module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qurin5-04914753966c295994fdb6d5b5d5d365.jpg";